/**
 * The copy of this screen and of the public page, CONTENT.md section 9 verbatim. The same
 * keys live in packages/shared/src/strings/ui.id.json (`ui.verifikasi`); test/verifikasi.test.ts
 * holds the two in step, so the components can carry the words without bundling the whole
 * registry into the public page.
 */
export const TEKS = {
  judul: 'Verifikasi sakramen',
  kalimat: 'Verifikasi mencari di semua paroki dan memerlukan koneksi.',
  cari: {
    judul: 'Cari di semua paroki',
    nama: 'Nama',
    tahunLahir: 'Tahun lahir',
    namaOrangTua: 'Nama orang tua (jika ada)',
    tombol: 'Cari',
    mencari: 'Mencari…',
    hasil:
      'Ditemukan {jumlah} catatan. Hanya jenis sakramen, paroki, referensi buku, tanggal dan pelayan yang ditampilkan.',
    kosong: 'Tidak ditemukan catatan yang cocok. Periksa penulisan nama atau tahun lahir.',
    namaPendek: 'Nama minimal 3 huruf.',
    tahunEmpatAngka: 'Tahun lahir 4 angka.',
    tanpaNomor: 'Cari dengan nama; NIK atau nomor lain tidak dipakai di sini.',
  },
  kode: {
    judul: 'Periksa nomor referensi',
    kodeVerifikasi: 'Nomor referensi',
    petunjuk: '8 huruf dan angka, contoh 7K3M-Q2ZP',
    tombol: 'Periksa',
    memeriksa: 'Memeriksa…',
    tidakDikenal:
      'Nomor referensi ini tidak tercatat di SATU. Periksa penulisannya atau tanyakan ke paroki penerbit.',
    digantikan: 'Digantikan oleh surat terbitan ulang tanggal {tanggal}.',
    terbitanUlang: 'Terbitan ulang; menggantikan surat tanggal {tanggal}.',
  },
  offline: 'Verifikasi memerlukan koneksi. Coba lagi saat terhubung.',
  batas: 'Batas 30 pencarian per menit tercapai. Coba lagi sebentar.',
  gagal: 'Belum berhasil. Coba lagi sebentar.',
  periksa: {
    judul: 'Periksa nomor referensi surat',
    kalimat:
      'Nomor referensi tercetak di bagian bawah surat yang diterbitkan melalui SATU Katedral Salib Suci Agats. Pemeriksaan memerlukan koneksi.',
    catatan: 'Hanya jenis surat, nama, paroki penerbit dan tanggal terbit yang ditampilkan.',
    /** The public card (release 15): the answer as the owner drew it, its three states. */
    kartu: {
      nomor: 'dengan nomor referensi {kode}',
      nomorSaja: 'Nomor referensi {kode}',
      asli: 'ASLI',
      asliKalimat: 'Surat ini tercatat di SATU dan masih berlaku.',
      digantikan: 'SUDAH DIGANTIKAN',
      digantikanKalimat:
        'Surat ini asli, tetapi sudah diganti oleh terbitan ulang tanggal {tanggal}. Mintalah surat yang terbaru.',
      tidakDitemukan: 'TIDAK DITEMUKAN',
      nama: 'Nama',
      kepalaKeluarga: 'Kepala keluarga',
      kepalaBelumTercatat: 'Belum tercatat',
      mempelai: 'Mempelai',
      diterbitkanOleh: 'Diterbitkan oleh',
      tanggalTerbit: 'Tanggal terbit',
    },
  },
  /** ui.umum.dikembangkanOleh: the developer's credit at the public page's foot (release 23). */
  dikembangkanOleh: 'Dikembangkan dan dipelihara oleh Genorah Labs Indonesia',
} as const

/** ui.validasi.kodeVerifikasi, the one sentence borrowed from the validators. */
export const KODE_BENTUK = 'Nomor referensi terdiri dari 8 huruf dan angka.'

/** Fill `{name}` placeholders (the shared `format`, without the shared bundle). */
export function isi(template: string, values: Record<string, string | number>): string {
  return template.replace(/\{([A-Za-z0-9_]+)\}/g, (whole, name: string) => {
    const value = values[name]
    return value === undefined ? whole : String(value)
  })
}
